import React from "react"
import { Box, Stack, Text } from "@chakra-ui/react"

export const Footer = () => {
  return (
    <Box as="footer" p="2">
      <Stack direction="row" justify="center">
        <Text as="span" fontSize="12px">
          Created by
          <a
            href="https://twitter.com/maki_saki"
            target="_blank"
            rel="noopener"
          >
            @maki_saki
          </a>
        </Text>
      </Stack>
    </Box>
  )
}
